/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'people.menu.renotify.flag.description': 'Všem zasíláme e-mail s připomenutím. Může to trvat až minutu.',
  'people.menu.renotify.flag.description.confluence': 'Pošlete kolegům připomenutí',
  'people.menu.renotify.flag.title': 'Odesílání připomenutí',
  'people.menu.renotify.flag.title.confluence': 'Opětovné odeslání e-mailu s pozvánkou',
  'people.menu.renotify.menu.description':
    '{userCount, plural, one {{userCount,number} člověk nepřijal pozvánku do produktu {product}. Podívejte se, kdo chybí, a pošlete mu připomenutí.} few {{userCount,number} lidé nepřijali pozvánku do produktu {product}. Podívejte se, kdo chybí, a pošlete jim připomenutí.} many {{userCount,number} člověka nepřijalo pozvánku do produktu {product}. Podívejte se, kdo chybí, a pošlete jim připomenutí.} other {{userCount,number} lidí nepřijalo pozvánku do produktu {product}. Podívejte se, kdo chybí, a pošlete jim připomenutí.}}',
  'people.menu.renotify.menu.description.confluence':
    'Někteří lidé nepřijal pozvánku do Confluence. Podívejte se, kdo chybí, a pošlete mu připomenutí.',
  'people.menu.renotify.menu.dismiss': 'Zavřít',
  'people.menu.renotify.menu.dismiss.confluence': 'Teď ne',
  'people.menu.renotify.menu.remind': 'Zaslat připomenutí členům týmu',
  'people.menu.renotify.menu.remind.confluence': 'Pošlete kolegům připomenutí',
  'people.menu.renotify.menu.title': 'Jsou tu s námi všichni?',
  'people.menu.renotify.modal.copied': 'Odkaz byl zkopírován',
  'people.menu.renotify.modal.copy': 'Kopírovat odkaz s pozvánkou',
  'people.menu.renotify.modal.description':
    'Chybějícím členům můžeme poslat připomenutí e-mailem, nebo můžete odkaz s pozvánkou sdílet sami.',
  'people.menu.renotify.modal.description.confluence':
    'Odešlete znovu e-mail s pozvánkou nebo zkopírujte a sdílejte zvací odkaz.',
  'people.menu.renotify.modal.dismiss': 'Zrušit',
  'people.menu.renotify.modal.resend': 'Odeslat připomenutí',
  'people.menu.renotify.modal.resend.confluence': 'Znovu odeslat pozvánku',
  'people.menu.renotify.modal.title': 'Zaslat připomenutí chybějícím členům',
  'people.menu.renotify.modal.title.confluence': 'Zaslat připomenutí chybějícím týmovým kolegům',
  'ptc.pm.collaborators.title': 'Vaši spolupracovníci',
  'ptc.pm.error-heading': 'Něco se pokazilo',
  'ptc.pm.error-image-alt-text': 'Rozbitý robot a lidé, kteří usilovně pracují na jeho opravě.',
  'ptc.pm.error-text': 'Tyto chyby sledujeme, ale klidně se na nás obraťte, pokud obnovení stránky problém nevyřeší.',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} člen} few {{memberCount,number} členové} many {{memberCount,number} člena} other {{memberCount,number} členů}}',
  'ptc.pm.people': 'Lidé',
  'ptc.pm.teams': 'Týmy',
  'ptc.pm.view-your-profile': 'Zobrazit váš profil',
  'ptc.pm.your-teams.title': 'Vaše týmy',
};
